import { readUtm } from "@/components/WhatsAppButton";

/** Regions where advertising data needs prior consent. We simply don't collect there. */
export const CONSENT_REGIONS = new Set([
  "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL",
  "PL","PT","RO","SK","SI","ES","SE","IS","LI","NO","GB","CH",
]);

let regionPromise: Promise<boolean> | null = null;

/** true = visitor is outside consent regions (country resolved via same-origin /cdn-cgi/trace). */
function trackingAllowedByRegion(): Promise<boolean> {
  if (regionPromise) return regionPromise;
  regionPromise = (async () => {
    try {
      const ctrl = new AbortController();
      const t = setTimeout(() => ctrl.abort(), 2000);
      const res = await fetch("/cdn-cgi/trace", { signal: ctrl.signal, cache: "no-store" });
      clearTimeout(t);
      if (!res.ok) return false;
      const loc = /(?:^|\n)loc=([A-Z0-9]{2})/.exec(await res.text())?.[1] ?? "";
      if (!loc || loc === "XX" || loc === "T1") return false;
      return !CONSENT_REGIONS.has(loc);
    } catch {
      return false;
    }
  })();
  return regionPromise;
}

function cookie(name: string): string {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}

/** Extra fields for submit-lead. Empty (tracking_allowed:false) in consent/unknown regions. */
export async function fbTrackingPayload(): Promise<{
  tracking_allowed: boolean;
  fbclid?: string;
  fbp?: string;
  fbc?: string;
}> {
  if (!(await trackingAllowedByRegion())) return { tracking_allowed: false };
  const utm = readUtm();
  const fbclid = utm.fbclid || "";
  let fbc = cookie("_fbc");
  if (!fbc && fbclid) fbc = `fb.1.${utm.savedAt || Date.now()}.${fbclid}`;
  return {
    tracking_allowed: true,
    fbclid: fbclid || undefined,
    fbp: cookie("_fbp") || undefined,
    fbc: fbc || undefined,
  };
}
